import axios from "axios";
import { Storage } from "utils/clientStorage";

const token = window !== undefined ? Storage.getItem("TOKEN") || "" :""

const  clientApi = axios.create({
  baseURL: "https://app.cowrie.services",
  headers: {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${token}`, // Input token
    "Access-Control-Allow-Origin": "*"
  },
});


export default clientApi;
